import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { AdaptiveLayoutState } from '../layout/adaptive-layout.service';
import { SubNavigationResolve } from '../sub-navigation/sub-navigation-resolve.service';
import { MultibuilderResponse } from './multi-builder.model';

@Injectable()
export class MultiBuilderSubnavigationResolve extends SubNavigationResolve<any> {
    constructor() {
        super();
    }

    buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot, model: MultibuilderResponse): void {
        if (model.subNavigationItems) {
            this.tabs$.next(model.subNavigationItems);
        }
    }
}
